module.exports = __webpack_public_path__ + "static/media/auto.8ba3a1f5.svg";